import { generateId } from '../../../utils';

export const generateTransferOverlayId = (variableLength?: number) =>
  generateId({ prefix: 'transfer-overlay', variableLength });
